import {
  isEmail,
  isExactChar,
  isOnlyNumber,
  isRequired,
} from '../../../utils/validation';

export const initialValues = {
  registrationId: '',
  nationalityId: '',
  storeName: '',
  ownerName: '',
  phoneNumber: '',
  storePhoneNumber: '',
  email: '',
  zipcode: '',
  street: '',
  coordinate: '',
  provinceId: '',
  cityId: '',
  districtId: '',
  villageId: '',
};

export const fieldsProps = {
  registrationId: {
    name: 'registrationId',
    placeholder: 'Masukkan ID Pangkalan',
    label: 'ID Pangkalan'
  },
  nationalityId: {
    name: 'nationalityId',
    placeholder: 'Masukkan No. KTP',
    label: 'No. KTP',
    maxlength: 16,
  },
  storeName: {
    name: 'storeName',
    placeholder: 'Masukkan Nama Pangkalan LPG 3 Kg',
    label: 'Nama Pangkalan LPG 3 Kg',
  },
  ownerName: {
    name: 'ownerName',
    placeholder: 'Masukkan Nama Pemilik',
    label: 'Nama Pemilik',
  },
  phoneNumber: {
    name: 'phoneNumber',
    placeholder: 'Masukkan No. Ponsel Pemilik',
    label: 'No. Ponsel Pemilik',
    maxlength: 20,
  },
  storePhoneNumber: {
    name: 'storePhoneNumber',
    placeholder: 'Masukkan No. Telepon Pangkalan LPG 3 Kg',
    label: 'No. Telepon Pangkalan LPG 3 Kg',
    maxlength: 20
  },
  email: {
    name: 'email',
    placeholder: 'Masukkan Email Pemilik',
    label: 'Email Pemilik',
  },
  zipcode: {
    name: 'zipcode',
    placeholder: 'Masukkan Kode Pos',
    label: 'Kode Pos',
    maxlength: 5
  },
  street: {
    name: 'street',
    placeholder: 'Masukkan Alamat',
    label: 'Alamat',
  },
  coordinate: {
    name: 'coordinate',
    placeholder: 'Masukkan Titik Koordinat',
    label: 'Titik Koordinat',
  },
  provinceId: {
    name: 'provinceId',
    placeholder: 'Pilih Provinsi',
    label: 'Provinsi',
  },
  cityId: {
    name: 'cityId',
    placeholder: 'Pilih Kota/Kabupaten',
    label: 'Kota/Kabupaten',
  },
  districtId: {
    name: 'districtId',
    placeholder: 'Pilih Kecamatan',
    label: 'Kecamatan',
  },
  villageId: {
    name: 'villageId',
    placeholder: 'Pilih Kelurahan',
    label: 'Kelurahan',
  },
};

export const validate = (values = initialValues) => {
  const {
    cityId,
    coordinate,
    districtId,
    email,
    nationalityId,
    ownerName,
    phoneNumber,
    provinceId,
    storeName,
    storePhoneNumber,
    street,
    villageId,
    zipcode,
  } = values;
  const rules = {
    nationalityId:
      isRequired(nationalityId, 'No. KTP harus diisi') ||
      isExactChar(16, nationalityId, 'No. KTP harus 16 digit agka'),
    storeName: isRequired(storeName, 'Nama Pangkalan LPG 3 Kg harus diisi'),
    ownerName: isRequired(ownerName, 'Nama Pemilik harus diisi'),
    phoneNumber: isRequired(phoneNumber, 'No. Ponsel Pemilik harus diisi'),
    storePhoneNumber: isRequired(
      storePhoneNumber,
      'No. Telepon Pangkalan LPG 3 Kg harus diisi'
    ),
    email: isRequired(email, 'Email Pemilik harus diisi') || isEmail(email, 'Email tidak sesuai format'),
    zipcode:
      isRequired(zipcode, 'Kode Pos harus diisi') ||
      isExactChar(5, zipcode, 'Kode Pos harus 5 digit angka') ||
      isOnlyNumber(zipcode, 'Kode Pos hanya boleh diisi angka'),
    street: isRequired(street, 'Alamat harus diisi'),
    coordinate: isRequired(coordinate, 'Titik Koordinat harus diisi'),
    provinceId: isRequired(provinceId, 'Provinsi harus dipilih'),
    cityId: isRequired(cityId, 'Kota/Kabupaten harus dipilih'),
    districtId: isRequired(districtId, 'Kecamatan harus dipilih'),
    villageId: isRequired(villageId, 'Kelurahan harus dipilih'),
  };

  return rules;
};
